import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Loader } from "src/components";
import { getSubCategory } from 'src/utils';
import HandbookHeader from './handbook-header';
import HandbookArticle from "./article/handbook-article";

export default function HandbookSubCategory() {
  const { slug, category } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getArticle = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await getSubCategory(slug);
        setArticle(res);
        
      } catch (err) {
          console.error("Error fetching article", err);
          setError("Failed to load article. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      getArticle();
    }
  }, [slug]);

  const articleTitleCase = slug.split('-')
    .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
    .join(' ');

  if (loading) {
    return (<Loader />);
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        background: '#FAFAFA',
        minHeight: '100%',
        overflowY: 'auto', 
        width: '100%',
        pb: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>

      {error ? (
          <HandbookHeader 
            id={category}
            title={articleTitleCase}
            description={"Failed to load article"}
            displayBackButton={true}
            displayErrorAlert={true} />
        ) : ( <>

        <HandbookHeader 
            id={article?.id}
            title={article?.shortTitle}
            description={article?.description}
            showControlButtons={true}
            category={category} 
            subcategory={article.slug}/>

        <HandbookArticle 
                id={article?.id}
                title={article?.title}
                markdown={article?.markdown}
                relatedArticles={article?.relatedArticles} />

        </>)}

    </Box>
  );
}